"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Total = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../ui");
var _ticker = require("../../ticker");
var _utils = require("../../../utils");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var HighlightedSegment = (0, _styledComponents.default)(_ui.HighlightedSegment)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex-direction: column;\n    ", " {\n      margin-bottom: 10px !important;\n    }\n  "])), _ui.H6));
var Total = function Total(props) {
  return /*#__PURE__*/_react.default.createElement(HighlightedSegment, {
    className: props.className
  }, /*#__PURE__*/_react.default.createElement(_ui.H6, {
    className: "m-0"
  }, props.label, ":"), props.value && /*#__PURE__*/_react.default.createElement(_ui.H3, {
    className: "m-0"
  }, /*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: props.ticker
  }), " ", /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    value: props.value,
    decimals: 2
  })));
};
exports.Total = Total;